import { render, staticRenderFns } from "./ProductFieldInfo.vue?vue&type=template&id=beec87f4&"
import script from "./ProductFieldInfo.vue?vue&type=script&lang=js&"
export * from "./ProductFieldInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports